export const apiConfig = {
    webCrmApi: process.env.REACT_APP_WEBCRM_API,
}